// ============================================================================
// FILE: src/pages/OrdersManagement/MobileView/components/adminNoteModal.jsx
// STATUS: FIXED - For Ant Design 4.x
// ============================================================================

import React, { useState, useEffect } from "react";
import { Modal, Input, Form, Button } from "antd";
import { FormattedMessage } from "react-intl";

const { TextArea } = Input;

export const AdminNoteModal = ({ visible, order, onSave, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && order) {
      console.log("📝 Setting form values for order:", order.id);
      form.setFieldsValue({
        adminNote: order.adminNote || "",
      });
    }
  }, [visible, order, form]);

  const handleSubmit = async () => {
    try {
      console.log("💾 Starting save process...");
      
      const values = await form.validateFields();
      console.log("✅ Form validation passed:", values);
      
      setLoading(true);

      await onSave({
        orderId: order.id,
        adminNote: values.adminNote,
      });

      console.log("✅ Save successful, closing modal");
      
      form.resetFields();
      onClose();
    } catch (error) {
      console.error("❌ Error in handleSubmit:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    console.log("🚪 Canceling, resetting form");
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={
        <FormattedMessage
          id="orders.adminNote.title"
          defaultMessage="Admin Note"
        />
      }
      visible={visible}  // ✅ FIXED: Changed from 'open' to 'visible' for Ant Design 4.x
      onCancel={handleCancel}
      width={600}
      footer={[
        <Button key="cancel" onClick={handleCancel} disabled={loading}>
          <FormattedMessage id="orders.adminNote.cancel" defaultMessage="Cancel" />
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          loading={loading}
        >
          <FormattedMessage id="orders.adminNote.save" defaultMessage="Save" />
        </Button>,
      ]}
      destroyOnClose
      className="admin-note-modal"
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          label={
            <FormattedMessage
              id="orders.adminNote.label"
              defaultMessage="Note"
            />
          }
          name="adminNote"
          rules={[
            {
              max: 500,
              message: "Note cannot exceed 500 characters",
            },
          ]}
        >
          <TextArea
            rows={6}
            placeholder="Enter admin note for this order..."
            maxLength={500}
            showCount
          />
        </Form.Item>

        {order && (
          <div className="order-info" style={{ marginTop: 16, padding: 12, backgroundColor: '#f5f5f5', borderRadius: 4 }}>
            <p style={{ margin: '4px 0' }}>
              <strong>Order ID:</strong> {order.id}
            </p>
            {order.customerInfo && (
              <p style={{ margin: '4px 0' }}>
                <strong>Customer:</strong> {order.customerInfo.name}
              </p>
            )}
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default AdminNoteModal;